export default "__VITE_ASSET__CdPdxQL9__"